import SilicaGelData from "../components/analysisComponents/tritio/tritioVapor/preparation/silicaGelData";
import Tracking from "../components/analysisComponents/tritio/tritioVapor/preparation/tracking";
import VolumeData from "../components/analysisComponents/tritio/tritioVapor/preparation/volumeData";
import {
  processingCalcinationMap,
  processingDigestionMap,
  processingDryingMap,
  processingEvaporationMap,
  processingGrindingMap,
  processingMap,
  processingSiftingMap,
  processingChippingMap,
} from "./helpers";

export const processingTablesDisabledTrue = {
  grinding: processingGrindingMap,
  sifting: processingSiftingMap,
  drying: processingDryingMap,
  calcination: processingCalcinationMap,
  evaporation: processingEvaporationMap,
  digestion: processingDigestionMap,
  chipping: processingChippingMap,
  not_applicable: processingMap,
};

export type MapKeys =
  | "sampling"
  | "sample-management"
  | "conditioning"
  | "processing";

export type MapValues =
  | "sampling"
  | "management"
  | "conditioning"
  | "processing";

export const mapsNameInitial: Record<MapKeys, MapValues> = {
  sampling: "sampling",
  "sample-management": "management",
  conditioning: "conditioning",
  processing: "processing",
};

export const configButtonAnalysis: {
  titleButton: string;
  label: string;
  type: string;
}[] = [
  {
    titleButton: "+ Nueva preparación",
    label: "Preparación",
    type: "preparation",
  },
  {
    titleButton: "+ Nuevo contaje",
    label: "Contaje",
    type: "counting",
  },
  {
    titleButton: "+ Nuevo cálculo",
    label: "Cálculo",
    type: "calculation",
  },
];

export const configButtonAnalysisFe55: {
  titleButton: string;
  label: string;
  type: string;
}[] = [
  {
    titleButton: "+ Nueva preparación",
    label: "Preparación",
    type: "preparation",
  },
  {
    titleButton: "+ Nueva medida",
    label: "Medida",
    type: "aa-measure",
  },
  {
    titleButton: "+ Nuevo contaje",
    label: "Contaje",
    type: "counting",
  },
  {
    titleButton: "+ Nuevo cálculo",
    label: "Cálculo",
    type: "calculation",
  },
];

export enum AnalysisType {
  PREPARATION = "preparation",
  MEASUREMENT = "aa-measure",
  COUNTING = "counting",
  CALCULATION = "calculation",
}

export const DEFAULT_LABORATORY = {
  id: 17,
  codigo: "35",
  descripcion: "Medidas Ambientales S.L.",
};

export const DEFAULT_EQUIPMENT_H = {
  id: 14,
  codigo: "3002",
  descripcion: "Contador centelleo líquido",
  codet: null,
  codigoviejo: null,
};

export const DEFAULT_EQUIPMENT: any = {
  1: [DEFAULT_EQUIPMENT_H],
};

export const DEFAULT_CRITERION = "5";

export const DEFAULT_VALID_PREPARATION = "NA";

export const DEFAULT_AMOUNT_SAMPLE = "1.00E-05";

export enum TYPE_METHOD_VAPOR {
  ISO = "ISO 11929",
  CURRIE = "Currie",
}

export enum TYPE_METHOD_IG_GT {
  GENIE = "Genie",
  AREA_EXE = "Area Exe",
}

export const prepratationVaporTabs: {
  label: string;
  component: React.ComponentType<any>;
}[] = [
  {
    label: "Datos volúmenes",
    component: VolumeData,
  },
  {
    label: "Datos silicagel",
    component: SilicaGelData,
  },
  {
    label: "Seguimiento",
    component: Tracking,
  },
];

export const typesSamplesOptions = ["MASL", "Externo"];

export enum TYPE_ANALYSIS_ALFATOTAL {
  EVAPORATION = "Evaporación",
  COPRECIPITATION = "Coprecipitación",
  PARTICLES = "Partículas de polvo/No aplica",
}

export const TYPE_ANALYSIS_ALFATOTAL_OPTIONS = [
  { id: 1, name: TYPE_ANALYSIS_ALFATOTAL.EVAPORATION },
  { id: 2, name: TYPE_ANALYSIS_ALFATOTAL.COPRECIPITATION },
  { id: 3, name: TYPE_ANALYSIS_ALFATOTAL.PARTICLES },
];

export enum UNIT_TYPES_CODES {
  HUMEDO = "2",
  SECO = "3",
}
